import { useCallback, useState } from "react";

/** Assumed nav-chrome height (px) when no chrome element is rendered to measure. */
export const DEFAULT_NAV_CHROME_BOTTOM = 64;

/** Bottom edge (px) of the active nav chrome: legacy `#header` or the side-nav `#top-bar`. */
export const useNavChromeBottom = () => {
	const [topOffset, setTopOffset] = useState<number | null>(null);

	const measureRef = useCallback((node: HTMLDivElement | null) => {
		if (node) {
			requestAnimationFrame(() => {
				const chrome = document.getElementById("header") ?? document.getElementById("top-bar");
				setTopOffset(chrome ? chrome.getBoundingClientRect().bottom : DEFAULT_NAV_CHROME_BOTTOM);
			});
		}
	}, []);

	return { topOffset, measureRef };
};
